module.exports = __webpack_public_path__ + "57be70b7ea8c95805a20ee301b281222.png";